export default __webpack_public_path__ + "static/media/627.4ba29fcb.png";